import { CUSTOMER_SUBSCRIPTION_STATUS } from '@/lib/constants';

export const CUSTOMER_SUBSCRIPTION_ACTION_OPTIONS: Record<number, Array<{ id: string; label: string }>> = {
    [CUSTOMER_SUBSCRIPTION_STATUS.ACTIVE]: [
        { id: 'copyBilling', label: 'Copy Billing Link' },
        { id: 'pause', label: 'Pause Subscription' },
        { id: 'cancel', label: 'Cancel Subscription' },
    ],
    [CUSTOMER_SUBSCRIPTION_STATUS.PAUSED]: [
        { id: 'renew', label: 'Renew Subscription' },
        { id: 'cancel', label: 'Cancel Subscription' },
    ],
};

export const ORDERS_EXPORT_PAGE_SIZE = 1000;
export const DEFAULT_RECORDS_PER_PAGE = 5;
export const EVERYONE_TAG = 'Everyone';
export const MAX_CUSTOM_TAG_LENGTH = 50;
export const TAG_CREATION_LIMIT = 100; // fail-safe for UI; backend enforces own rules.
export const CSV_CONCURRENT_REQUESTS = 5;
